<template>
  <div :class="{TA:isTestAchat}">
    <v-select
      v-if="isBelgian && !manualInput"
      class="select"
      @search="fetchOptions"
      :filterable="false"
      label="label"
      :components="{Deselect, OpenIndicator}"
      :value="value"
      :options="options"
      @input="setSelected"
      @search:blur="$emit('blur')"
    >
      <template slot="no-options">
        {{ $t('noStreet')}}
      </template>
    </v-select>
    <input v-if="!isBelgian || manualInput" class="input" type="text"
      v-bind:value="value"
      v-on:blur="onBlurStreet($event.target.value)"
      v-on:input="$emit('input', $event.target.value)"/>
  </div>
</template>

<script>
import vSelect from "vue-select";
import streetService from "@/services/streetService";
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      options: [],
    };
  },
  computed: {
    ...mapGetters("subscription", ["isTestAchat"]),
    isBelgian() {
      return this.country === 'BE';
    },
    isFrance() {
      return this.country === 'FR';
    },
    OpenIndicator() {
      return null;
    },
    Deselect() {
      return null;
    },
  },
  props: {
    country: {
      type: String,
      required: false,
      default: "BE",
    },
    locality: Object,
    value: {
      type: null,
    },
    manualInput: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  methods: {
    capitalizeStreetWords(value) {
      String.prototype.capitalize = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
      }

      let gluewords = ['du', 'de', 'des', 'le', 'la', 'les', 'van', 'à', 'l', 'd', 't'];
      let newStreet = value.toLowerCase();

      [" ", "'", "-", "."].forEach(delimiter => {
        newStreet = newStreet.split(delimiter).map(word => {
          if(!gluewords.includes(word)){ return word.capitalize(); } else {return word.toLowerCase();}}).join(delimiter);
      });

      return newStreet.replace("D'","d'").replace("L'","l'");
    },
    onBlurStreet(value) {
      if (value && ((this.isBelgian && this.manualInput) || this.isFrance)) {
        this.$emit("input", this.capitalizeStreetWords(value));
      }

      this.$emit("blur");
    },
    setSelected(value) {
      this.$emit("input", value);
    },
    replaceStreetSpecialChars(value) {
      return value.replace(/\((.{1,3})\)/, (_match, p1) => "- " + p1.toUpperCase())
        .replace("(", "")
        .replace(")", "")
        .replace("ß", "ss");
    },
    async getStreets(search) {
      if (this.locality.region === 'wl') {
        if (!this.locality.ident) {
          let zones = await streetService.getWalloniaZone(this.locality.zipCode);
          let result = zones.candidates ? zones.candidates.find(e => e.city && e.city.ident) : null;
          if (result) {
            this.locality.ident = result.city.ident
          }
        }

        let ident = this.locality.ident;
        streetService.cancelRequest();
        let response = await streetService.getWalloniaStreets(ident, search, 'fr');
        if (!response || !response.candidates.length) {
          this.options = [];
        } else {
          let countMissingTrad = response.candidates.filter(e => e.street && !e.street.name).length;
          let allStreets = null;
          if (countMissingTrad) {
            allStreets = await streetService.getWalloniaStreets(ident, search);
          }
          this.options = response.candidates.filter(e => e.street).map(candidate => {
            let newStreet = '';
            if (candidate.street.name) {
              newStreet = candidate.street.name;
            } else if (allStreets) {
              let st = allStreets.candidates.find(e => e.street && e.street.ident === candidate.street.ident);
              if (st.street.name) {
                newStreet = st.street.name;
              }
            }

            newStreet = this.capitalizeStreetWords(newStreet);
            return this.replaceStreetSpecialChars(newStreet);
          });
        }
      }
      else {
        let response = await streetService.getStreets(search+','+this.locality.zipCode);
        if (response && response.SuggestionResult.length === 0) {
          response = await streetService.getStreets(search+','+this.locality.town);
        }
        if (response) {
          this.options = response.SuggestionResult.map(s => {
            let newStreet = s.split(',')[0];
            return this.replaceStreetSpecialChars(newStreet);
          });
        } else {
          this.options = [];
        }
      }
    },
    async fetchOptions(search, loading) {
      const searchLength = search.length;
      if (searchLength > 2 && !!(searchLength % 2)) {
        loading(true);
        await this.getStreets(search);
        this.$emit("input", search); // IS-4763: remove if we re-enable a checkbox
        loading(false);
      }
    },
  },
  created() {
  },
  components: {
    vSelect,
  },
};
</script>

<style lang="scss" scoped>
/deep/ .select .vs__dropdown-toggle {
  font-family: "ObjectSans", Helvetica, Arial, sans-serif;
  font-size: 1rem;
  padding: 1px;
  border-radius: 4px;
  border: 2px solid $yellow;
  min-width: 100px;
}

/deep/ .select .vs__dropdown-menu {
  background: $white;
  border: 2px solid $yellow;
  border-top: 0;
  color: $black;
}

/deep/ .vs__search {
  font-family: "ObjectSans", Helvetica, Arial, sans-serif;

  &::placeholder {
    color: $grey;
  }
}

.TA {
  /deep/ .select .vs__dropdown-toggle {
    border: 2px solid $pink!important;
    font-family: 'Lato', Helvetica, Arial, sans-serif;
  }

  /deep/ .select .vs__dropdown-menu {
    border: 2px solid $pink!important;
  }

  /deep/ .vs__search {
    font-family: "Lato", Helvetica, Arial, sans-serif;
  }
}

.street-checkbox {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Form/BecomeFields/StreetField.vue